import { useEffect, useLayoutEffect, useRef } from 'react'

export function useEventListener({ elementRef, eventName, handler }) {
  const handlerRef = useRef(handler)

  useLayoutEffect(() => {
    if (handler) {
      handlerRef.current = handler
    }
  }, [handler])

  useEffect(() => {
    if (handler) {
      const element = elementRef?.current ?? document

      if (!element) {
        return
      }

      function listener(event) {
        return handlerRef.current(event)
      }

      element.addEventListener(eventName, listener)

      return () => {
        element.removeEventListener(eventName, listener)
      }
    }
  }, [elementRef, eventName])
}
